import React, {useState, useEffect} from 'react';
import { AutoComplete, Input } from "antd";
import {CaretDownOutlined} from "@ant-design/icons";
import {api} from "@redux/api";

const SYSTEM_OPTION_VALUE = "__SYSTEM__";

const CompanyLookup = ({
    value,
    formRef,
    allowSystemOption = false,
    disabled = false,
    disabledDisplayValue,
}) => {
    const [options, setOptions] = useState([]);
    const [val, setVal] = useState("");

    useEffect(() => {
        const next =
            disabledDisplayValue != null && `${disabledDisplayValue}`.trim() !== ""
                ? disabledDisplayValue
                : value;
        if (next != null && `${next}`.trim() !== "") {
            setVal(String(next));
        } else if (!disabled) {
            setVal("");
        }
    }, [value, disabledDisplayValue, disabled]);

    const mapCompanyOptions = (rows) =>
        rows.map((c) => ({
            label: c.name,
            value: c.name,
            id: c.id,
        }));

    const prependSystem = (list) => {
        if (!allowSystemOption) {
            return list;
        }
        return [
            {
                label: "System",
                value: SYSTEM_OPTION_VALUE,
                id: null,
            },
            ...list,
        ];
    };

    const handleFocus = async () => {
        try {
            const res = await api.filterCompany("page=1&page_size=999");
            const data = res?.data?.results || [];
            setOptions(prependSystem(mapCompanyOptions(data)));
        } catch { /* ignore */ }
    };

    const handleSearch = async (keyword) => {
        try {
            const res = await api.filterCompany(`search=${keyword}&page_size=50`);
            const data = res?.data?.results || [];
            setOptions(prependSystem(mapCompanyOptions(data)));
        } catch { /* ignore */ }
    };

    const handleSelect = (_, option) => {
        if (option.value === SYSTEM_OPTION_VALUE) {
            setVal("System");
            formRef?.setFieldsValue({ company: null });
            return;
        }
        setVal(option.label);
        formRef?.setFieldsValue({ company: option.id });
    };

    if (disabled) {
        return (
            <Input
                size="medium"
                disabled
                value={disabledDisplayValue != null ? disabledDisplayValue : val}
            />
        );
    }

    return (
        <AutoComplete
            style={{width: '100%'}}
            options={options}
            onFocus={handleFocus}
            onSelect={handleSelect}
            onSearch={handleSearch}
            value={val}
            onChange={setVal}
            dropdownMatchSelectWidth={false}
        >
            <Input size="medium" autoComplete="none" suffix={<CaretDownOutlined/>}/>
        </AutoComplete>
    );
};

export default CompanyLookup;
